import * as React from "react";
import ProductTeaser, { IProductTeaserProps } from "../product-teaser/product-teaser";
import ProductReviewSlider, {
    ProductReviewSliderProps
} from "../product-review-slider/product-review-slider";

export type AuthorFeaturedProductProps = IProductTeaserProps & ProductReviewSliderProps;

const AuthorFeaturedProduct: React.FC<AuthorFeaturedProductProps> = props => {
    return (
        <div className="author-featured-product">
            <ProductTeaser {...props} />
            {props.productReviews.length > 0 && <ProductReviewSlider {...props} />}
        </div>
    );
};

export default AuthorFeaturedProduct;
